module.exports = __webpack_public_path__ + "img/solu4.2aee4896.png";